import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-maintenance-templates',
  templateUrl: './maintenance-templates.component.html',
  styleUrls: ['./maintenance-templates.component.sass']
})
export class MaintenanceTemplatesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
